import {
  CREATE_CAMPUS_SUCCESS,
  CREATE_CATEGORIES_SUCCESS,
  CREATE_TERMS_SUCCESS,
  DELETE_CAMPUS_SUCCESS,
  DELETE_CATEGORIES_SUCCESS,
  DELETE_TERMS_SUCCESS,
  GET_ALL_CAMPUS_SUCCESS,
  GET_ALL_CATEGORIES_SUCCESS,
  GET_ALL_TERMS_SUCCESS,
  GET_CAMPUS_SUCCESS,
  GET_CATEGORIES_SUCCESS,
  GET_TERMS_SUCCESS,
  RESET_CAMPUS_DETAILS,
  RESET_CATEGORIES_DETAILS,
  RESET_TERMS_DETAILS,
  UPDATE_CAMPUS_SUCCESS,
  UPDATE_CATEGORIES_SUCCESS,
  UPDATE_TERMS_SUCCESS,
} from "../constants";
import { cloneDeep, remove, findIndex } from "lodash";

export const initialState = {
  termsDetails: undefined,
  campusDetails: undefined,
  categoriesDetails: undefined,
  campusList: [],
  termList: [],
  categoriesList: [],
};
export const CourseDataReducers = (state = initialState, action) => {
  //switch between action.type
  switch (action.type) {
    case GET_TERMS_SUCCESS: {
      return {
        ...state,
        termsDetails: action.payload,
      };
    }
    case DELETE_TERMS_SUCCESS: {
      const tempTermsDetails = cloneDeep(state.termsDetails);
      remove(tempTermsDetails.data, (obj) => obj._id === action.payload);
      return {
        ...state,
        termsDetails: tempTermsDetails,
      };
    }
    case UPDATE_TERMS_SUCCESS: {
      const tempTermsDetails = cloneDeep(state.termsDetails);
      const index = findIndex(tempTermsDetails.data, {
        _id: action.payload.id,
      });
      if (index !== -1) {
        const updatedObj = { ...action.payload, _id: action.payload.id };
        tempTermsDetails.data.splice(index, 1, updatedObj);
      }
      return {
        ...state,
        termsDetails: tempTermsDetails,
      };
    }
    case CREATE_TERMS_SUCCESS: {
      const tempTermsDetails = cloneDeep(state.termsDetails);
      tempTermsDetails.data.splice(0, 0, action.payload);

      return {
        ...state,
        termsDetails: tempTermsDetails,
      };
    }
    case RESET_TERMS_DETAILS: {
      return {
        ...state,
        termsDetails: undefined,
      };
    }
    case GET_ALL_TERMS_SUCCESS: {
      return {
        ...state,
        termList: action.payload,
      };
    }
    // Campus Reducers
    case GET_CAMPUS_SUCCESS: {
      return {
        ...state,
        campusDetails: action.payload,
      };
    }
    case DELETE_CAMPUS_SUCCESS: {
      const tempCampussDetails = cloneDeep(state.campusDetails);
      remove(tempCampussDetails.data, (obj) => obj._id === action.payload);
      return {
        ...state,
        campusDetails: tempCampussDetails,
      };
    }
    case UPDATE_CAMPUS_SUCCESS: {
      const tempCampusDetails = cloneDeep(state.campusDetails);
      const index = findIndex(tempCampusDetails?.data, {
        _id: action.payload.id,
      });
      if (index !== -1) {
        const updatedObj = { ...action.payload, _id: action.payload.id };
        tempCampusDetails?.data.splice(index, 1, updatedObj);
      }
      return {
        ...state,
        campusDetails: tempCampusDetails,
      };
    }
    case CREATE_CAMPUS_SUCCESS: {
      const tempCampusDetails = cloneDeep(state.campusDetails);
      tempCampusDetails.data.splice(0, 0, action.payload);
      return {
        ...state,
        campusDetails: tempCampusDetails,
      };
    }
    case RESET_CAMPUS_DETAILS: {
      return {
        ...state,
        campusDetails: undefined,
      };
    }
    case GET_ALL_CAMPUS_SUCCESS: {
      return {
        ...state,
        campusList: action.payload,
      };
    }

    case GET_CATEGORIES_SUCCESS: {
      return {
        ...state,
        categoriesDetails: action.payload,
      };
    }
    case DELETE_CATEGORIES_SUCCESS: {
      const tempCategoriesDetails = cloneDeep(state.categoriesDetails);
      remove(tempCategoriesDetails.data, (obj) => obj._id === action.payload);
      return {
        ...state,
        categoriesDetails: tempCategoriesDetails,
      };
    }
    case UPDATE_CATEGORIES_SUCCESS: {
      const tempCategoriesDetails = cloneDeep(state.categoriesDetails);
      const index = findIndex(tempCategoriesDetails.data, {
        _id: action.payload.id,
      });
      if (index !== -1) {
        const updatedObj = { ...action.payload, _id: action.payload.id };
        tempCategoriesDetails.data.splice(index, 1, updatedObj);
      }
      return {
        ...state,
        categoriesDetails: tempCategoriesDetails,
      };
    }
    case CREATE_CATEGORIES_SUCCESS: {
      const tempCategoriesDetails = cloneDeep(state.categoriesDetails);
      tempCategoriesDetails.data.splice(0, 0, action.payload);
      return {
        ...state,
        categoriesDetails: tempCategoriesDetails,
      };
    }
    case RESET_CATEGORIES_DETAILS: {
      return {
        ...state,
        categoriesDetails: undefined,
      };
    }
    case GET_ALL_CATEGORIES_SUCCESS: {
      return {
        ...state,
        categoriesList: action.payload,
      };
    }
    default:
      return state;
  }
};
